<!doctype html>
<html lang="en">
  <head>
    <meta charset="UTF-8" />
    <meta name="viewport" content="width=device-width, initial-scale=1.0" />
    <link rel="icon" href="/images/favicon.ico" type="image/x-ico" />
    <title>东方煤炭合同模板设计器</title>
  </head>
  <body>
    <script>
      var global = globalThis
    </script>
    <div id="root"></div>
    <script type="module" src="./src/main.tsx"></script>
  </body>
</html>
